<template>
    <div class="three_table">
        <div class="inputCont">
            <el-form
                style="width: 100%"
                :model="searchForm"
                class="leader-style-form leader-form-inner-tab-inline"
                :inline="true"
            >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="设备名称">
                            <el-input v-model="searchForm.device_ledger_name" maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="设备类型" prop="device_ledger_type" label-width="120px">
                            <el-select
                                v-model="searchForm.device_ledger_type"
                                placeholder="请选择设备类型"
                                style="width: 100%"
                                clearable
                            >
                                <el-option
                                    v-for="item in deviceLedgerList"
                                    :key="item.code_value"
                                    :label="item.code_name"
                                    :value="item.code_value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                        <el-button
                            @click="getDeviceLedgerList"
                            size="small"
                            class="leader-common-button"
                        >查询</el-button>
                        <el-button class="leader-common-button" @click="addItem" size="small">新增</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <!-- -------------------------- -->
        <!-- table布局 -->
        <div class="table-wrap" style="height: 100%; width: 100%" v-loading="loading">
            <el-table
                class="leader-style-table"
                :data="tableList"
                ref="multipleTable"
                height="100%;"
            >
                <el-table-column label="设备名称" property="device_ledger_name"></el-table-column>
                <el-table-column label="设备类型" property="device_ledger_type_name"></el-table-column>
                <el-table-column label="设备序号" property="device_number"></el-table-column>
                <el-table-column label="设备型号" property="device_model"></el-table-column>
                <el-table-column label="设备变比" property="device_ratio"></el-table-column>
                <el-table-column label="主要参数指标" property="main_parameters"></el-table-column>
                <el-table-column label="状态" property="device_status_name"></el-table-column>
                <el-table-column label="制造厂" property="manufacturer"></el-table-column>
                <el-table-column label="出厂编号" property="serial_number" align="center"></el-table-column>
                <el-table-column label="投运日期" property="up_time" align="center"></el-table-column>
                <el-table-column label="产权单位" property="property_unit" align="center"></el-table-column>
                <el-table-column label="制造厂" property="manufacturer" align="center"></el-table-column>
                <el-table-column label="设备状态" property="device_status_name" align="center"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="viewItem(scope.row)"
                            type="text"
                            class="leader-button start-button"
                        >
                            <i class="iconfont iconchakan"></i>
                            <span class="inner-text">查看</span>
                        </el-button>
                        <el-button
                            @click="changeItem(scope.row)"
                            type="text"
                            class="leader-button edit-button"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="leader-button del-button"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
                v-if="this.paginationData.totalNum"
            ></pagination>
        </div>
        <!-- -------------------------------- -->
        <!-- 新增dialog -->
        <el-dialog
            title="变电所台账管理"
            class="leader-dialog"
            :visible.sync="addshow"
            :close-on-click-modal="false"
            @close="dialogClose('addForm')"
        >
            <div class="substation_outer_wrapper">
                <div class="table-container" style="width: 100%;">
                    <el-form
                        label-width="150px"
                        :model="addForm"
                        :rules="addRules"
                        ref="addForm"
                        class="leader-style-form"
                        :show-message="false"
                    >
                        <el-scrollbar style="height: 22rem;margin-right: -1px">
                            <el-row :gutter="20">
                                <div class="circle_wrapper">
                                    <div class="circle_title">运行参数</div>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备名称"
                                            prop="device_ledger_name"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_ledger_name"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备类型"
                                            prop="device_ledger_type"
                                            label-width="120px"
                                        >
                                            <el-select
                                                v-model="addForm.device_ledger_type"
                                                placeholder="请选择设备类型"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in deviceLedgerList"
                                                    :key="item.code_value"
                                                    :label="item.code_name"
                                                    :value="item.code_value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备序号"
                                            prop="device_number"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_number"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备型号"
                                            prop="device_model"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_model"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备状态"
                                            prop="device_status"
                                            label-width="120px"
                                        >
                                            <el-select
                                                v-model="addForm.device_status"
                                                placeholder="请选择设备状态"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in deviceStatusList"
                                                    :key="item.code_value"
                                                    :label="item.code_name"
                                                    :value="item.code_value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="出厂编号"
                                            prop="serial_number"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.serial_number"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="主要指标参数"
                                            prop="main_parameters"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.main_parameters"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="投运日期"
                                            prop="up_time"
                                            label-width="120px"
                                        >
                                            <el-date-picker
                                                v-model="addForm.up_time"
                                                align="right"
                                                type="date"
                                                :clearable="false"
                                                placeholder="选择日期"
                                                value-format="yyyy-MM-dd"
                                                :picker-options="pickerOptions"
                                            ></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备电压等级"
                                            prop="voltage_level"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.voltage_level"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备变比"
                                            prop="device_ratio"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_ratio"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                                <div class="circle_wrapper">
                                    <div class="circle_title">资产参数</div>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="产权单位"
                                            prop="property_unit"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.property_unit"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="所属单位"
                                            prop="affiliation"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.affiliation"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                                <div class="circle_wrapper">
                                    <div class="circle_title">物理参数</div>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="制造厂"
                                            prop="manufacturer"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.manufacturer"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="使用地点"
                                            prop="use_place"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.use_place"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备原值"
                                            prop="former_value"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.former_value"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="防护等级"
                                            prop="protection_level"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.protection_level"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="柜体尺寸"
                                            prop="cabinet_size"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.cabinet_size"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="备注" label-width="120px" prop="remark">
                                            <el-input
                                                type="textarea"
                                                :rows="6"
                                                maxlength="200"
                                                v-model="addForm.remark"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                            </el-row>
                        </el-scrollbar>
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addshow = false" class="leader-common-button" size="small">取 消</el-button>
                <el-button
                    type="primary"
                    @click="addcommit"
                    :disabled="this.$store.state.btnType"
                    size="small"
                    class="leader-common-button"
                >确 定</el-button>
            </div>
        </el-dialog>
        <!-- -------------------------------- -->
        <!-- 查看dialog -->
        <el-dialog
            class="leader-dialog equipment_dialog"
            title="查看"
            :visible.sync="detailsShow"
            :close-on-click-modal="false"
        >
            <!-- <div class="circle_wrapper">
            <div class="circle_title">其他参数</div>-->
            <el-scrollbar style="height: 22rem;margin-right: -1px">
                <div v-for="(value, key) in detailTableData" :key="key" class="circle_wrapper">
                    <div class="circle_title">{{ key }}</div>
                    <mailTable :tableData="value" :tableStyle="{ width: '100%' }"></mailTable>
                </div>
            </el-scrollbar>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "../api/substation_device_manage";
import pagination from "@/comon/components/pagination.vue";
import { getCodelistByKind, uploadAvatar } from "@/http/api.js";
import Tree from "@/comon/components/tree.vue";
import mailTable from "@/comon/components/TableComponent.vue";
export default {
    components: {
        pagination,
        //BtnDialog,
        "me-tree": Tree,
        mailTable: mailTable
    },
    props: ["treeId", "treeLevel", "treeData"],
    data() {
        return {
            types: [],
            tableList: [],
            width: "calc(100% - 250px)",
            paginationData: {
                pageNum: "",
                pageSize: "",
                totalNum: "",
            },
            searchForm: {
                device_ledger_name: '',
                device_ledger_type: "",
            },
            deviceLedgerList: [],
            addshow: false,
            addForm: {
                device_ledger_name: "",
                device_ledger_type: "",
                device_number: "",
                device_model: '',
                device_status: '',
                main_parameters: '',
                up_time: null,
                voltage_level: "",
                device_ratio: "",
                property_unit: '',
                affiliation: '',
                manufacturer: '',
                use_place: '',
                former_value: '',
                protection_level: '',
                serial_number: '',
                cabinet_size: '',
                remark: '',
            },
            addRules: {
                device_ledger_name: [
                    {
                        required: true,
                        message: "请填写设备名称",
                        trigger: "blur",
                    },
                ],
                device_ledger_type: [
                    {
                        required: true,
                        message: "请选择设备类型",
                        trigger: "change",
                    },
                ],
                device_status: [
                    {
                        required: true,
                        message: "请选择设备状态",
                        trigger: "change",
                    },
                ],
                // device_number: [
                //     {
                //         required: true,
                //         message: "请输入设备序号",
                //         trigger: "blur",
                //     },
                // ],
                // up_time: [
                //     {
                //         required: true,
                //         message: "请选择投运日期",
                //         trigger: "change",
                //     },
                // ],
                // voltage_level: [
                //     {
                //         required: true,
                //         message: "请输入设备电压等级",
                //         trigger: "blur",
                //     },
                // ],
            },
            flag: true,
            btnVsb: false,
            title: "新增按钮",
            menuId: "",
            btnId: "",
            loading: false,
            equipmentStateList: [],
            deviceStatusList: [],
            detailsShow: false,
            detailTableData: {},
            isAdd: true,
        };
    },
    created() {
        this.getCodelistByKind();
    },
    methods: {
        getCodelistByKind() {
            getCodelistByKind({
                code_kind: "device_ledger_type_40;device_status",
            }).then((res) => {
                if (res) {
                    this.deviceLedgerList = res.bus_json[0].codelists;
                    this.deviceStatusList = res.bus_json[1].codelists;
                }
            });
        },
        getDeviceLedgerList() {
            this.loading = true;
            api.getDeviceLedgerList({
                ...this.searchForm,
                p_device_ledger_id: this.treeId,
                device_ledger_kind: this.treeData.device_ledger_kind,
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
            }).then((res) => {
                this.tableList = res.bus_json.items;
                this.paginationData.pageNum = res.bus_json.pageNum;
                this.paginationData.pageSize = res.bus_json.pageSize;
                this.paginationData.totalNum = res.bus_json.totalNum;
                //  this.$refs.multipleTable.doLayout();
            });
            this.loading = false;
        },
        //  table新增按钮点击
        addItem() {
            this.isAdd = true;
            this.width = "calc(100% - 250px)";
            this.addForm = {
                device_ledger_name: "",
                device_ledger_type: "",
                device_number: "",
                device_model: '',
                device_status: '',
                main_parameters: '',
                up_time: null,
                voltage_level: "",
                device_ratio: "",
                property_unit: '',
                affiliation: '',
                manufacturer: '',
                use_place: '',
                former_value: '',
                protection_level: '',
                serial_number: '',
                cabinet_size: '',
                remark: '',
            };
            this.addshow = true;
        },
        // 分页器公共方法
        paginationDataNew(sth) {
            this.paginationData = sth;
            this.getDeviceLedgerList();
        },
        // 新增资源提交
        addcommit() {
            this.$refs["addForm"].validate((valid) => {
                if (!this.treeId) {
                    this.$message({
                        message: '请选择设备',
                        type: "warning",
                    });
                    return;
                }
                if (valid) {
                    const param = [{
                        ...this.addForm
                    }];
                    if (this.isAdd) {
                        param.map(item => {
                            item.p_device_ledger_id = this.treeId;
                            item.device_ledger_kind = this.treeData.device_ledger_kind;
                        })
                    }
                    api.saveDeviceLedger(param).then((res) => {
                        if (res) {
                            this.addshow = false;
                            this.$message({
                                message: res.error_msg,
                                type: "success",
                            });
                            this.getDeviceLedgerList();
                            this.diaClose();
                        }
                    });
                }
            });
        },
        // 所有关闭dialog的清除验证的回调
        diaClose() {
            this.addshow = false;
            this.$emit('reloadTree');
        },
        // table内点击修改弹窗
        changeItem(sth) {
            this.isAdd = false;
            this.width = "100%";
            api.selectByDeviceLedgerId({
                device_ledger_id: sth.device_ledger_id,
            }).then((res) => {
                if (res) {
                    this.addForm = res.bus_json;
                    this.addshow = true;
                }
            });
        },
        viewItem(sth) {
            this.detailTableData = {};
            api.selectByDeviceLedgerId({
                device_ledger_id: sth.device_ledger_id,
            }).then((res) => {
                if (res) {
                    this.detailTableData['运行参数'] = [
                        { key: '设备名称', value: res.bus_json.device_ledger_name },
                        { key: '设备类型', value: res.bus_json.device_ledger_type_name },
                        { key: '设备序号', value: res.bus_json.device_number },
                        { key: '设备型号', value: res.bus_json.device_model },
                        { key: '设备状态', value: res.bus_json.device_status_name },
                        { key: '主要指标参数', value: res.bus_json.main_parameters },
                        { key: '投运日期', value: res.bus_json.up_time },
                        // {key: '数量', value: res.bus_json.amount},
                        { key: '设备电压等级', value: res.bus_json.voltage_level },
                        { key: '设备变比', value: res.bus_json.device_ratio },
                    ];
                    this.detailTableData['资产参数'] = [
                        { key: '产权单位', value: res.bus_json.property_unit },
                        { key: '所属单位', value: res.bus_json.affiliation },
                        // {key: '附件', value: res.bus_json.device_url},
                    ];
                    this.detailTableData['物理参数'] = [
                        { key: '制造厂', value: res.bus_json.manufacturer },
                        { key: '使用地点', value: res.bus_json.use_place },
                        { key: '设备原值', value: res.bus_json.former_value },
                        { key: '防护等级', value: res.bus_json.protection_level },
                        { key: '出厂编号', value: res.bus_json.serial_number },
                        { key: '柜体尺寸', value: res.bus_json.cabinet_size },
                        { key: '备注', value: res.bus_json.remark },
                    ];
                    this.detailsShow = true;
                }
            });
        },
        // 删除menuTable的一项
        deleteItemShow(sth) {
            this.$confirm("确认删除该数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deleteDeviceLedger({ device_ledger_id: sth.device_ledger_id }).then(res => {
                    if (res) {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.paginationData.totalNum -
                            (this.paginationData.pageNum - 1) *
                            this.paginationData.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.paginationData.pageNum =
                                this.paginationData.pageNum == 1
                                    ? this.paginationData.pageNum
                                    : this.paginationData.pageNum - 1;
                        }
                        // 刷新列表
                        this.getDeviceLedgerList();
                        this.diaClose();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
    },
    watch: {
        treeId(newVal) {
            if (newVal) {
                this.paginationData = {
                    pageNum: "1",
                    pageSize: "10",
                    totalNum: "",
                };
                this.tableList = [];
                this.getDeviceLedgerList();
            }
        },
    },
};
</script>
<style lang='scss'>
.three_table {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 90px);

    .inputCont {
        padding: 8px 0;
        margin: 0 !important;
    }
    .el-dialog {
        width: 1000px;
    }
    .leader-style-form {
        &::after {
            height: 0;
        }
    }
    .circle_wrapper {
        border: 3px solid #1a6292;
        padding: 30px 20px 0 30px;
        margin: 8px 0 20px 0;
        position: relative;
        .circle_title {
            position: absolute;
            top: -0;
            left: 20px;
            transform: translate(0, -50%);
            color: #fff;
            background-color: #0b1929;
            font-size: 14px;
        }
    }
    .leader-style-table .el-table__body-wrapper {
        height: 90% !important;
    }
    .color_green {
        color: #009788;
    }
    .color_red {
        color: red;
    }
    .leader-tab {
        position: relative;
        .btnContainer {
            width: auto;
            position: absolute;
            right: 32px;
            top: -29px;
        }
    }
}
</style>


